import React from 'react';

class Instructions extends React.Component {

    render() {
        return <div className="modal-content">
            <div className="modal-header modal-instrucciones">
                <button type="button" className="close" data-dismiss="modal" onClick={this.props.close}>×</button>
                <h1>Instrucciones</h1>
                <p>Esta herramienta permite calcular el aumento máximo que podrían tener algunos bienes y servicios con la transformación del tributo de ventas al impuesto sobre el valor agregado (IVA). <br /><br />
                    También permite conocer cuáles bienes y servicios estarán exonerados y cuáles seguirán pagando el mismo impuesto del 13% que ya existía. <br /><br />
                    Al mismo tiempo, el usuario podrá saber si su salario se verá impactado con las dos nuevas tarifas del impuesto sobre la renta y podrá estimar el monto de más que deberá desembolsar, según su sueldo mensual.</p>
            </div>
            <div className="modal-body">
                <div className="content">
                    <ul className="list">
                        <li>
                            <span className="name">Paso 1</span>
                            <span className="text">Seleccione alguna de las cinco categorías.</span>
                            <span className="image"><object width="100%" data="img/instructions001.svg"></object></span>
                        </li>

                        <li>
                            <span className="name">Paso 2</span>
                            <span className="text">Ahora seleccione una subcategoría para que le aparezca la respectiva lista de bienes o servicios.</span>
                            <span className="image"><object width="100%" data="img/instructions002.svg"></object></span>
                        </li>

                        <li>
                            <span className="name">Paso 3</span>
                            <span className="text">Ingrese el monto estimado que usted gasta en la compra de ese producto o servicio y presione el botón agregar. En el botón <b>ⓘ</b> podrá encontrar más información sobre ese bien o servicio.</span>
                            <span className="image"><object width="100%" data="img/instructions003.svg"></object></span>
                        </li>
                        <li>
                            <span className="name">Paso 4</span>
                            <span className="text">Una vez que haya seleccionado los productos y servicios de su consumo habitual presione el botón <b>"VER CARRITO"</b> para conocer cuánto pagaba antes de la reforma y cuándo pagará ahora. </span>
                            <span className="image"><object width="100%" data="img/instructions004.svg"></object></span>
                        </li>
                        <li>
                            <span className="name">Paso 5</span>
                            <span className="text">Presione el botón <b>"DESCARGAR FACTURA"</b> para obtener un PDF con el desglose de sus gastos y el impacto del IVA y la renta en su bolsillo. </span>
                            <span className="image"><object width="100%" data="img/instructions005.svg"></object></span>
                        </li>
                        <li>
                            <span className="name">Paso 6</span>
                            <span className="text">Presione el botón <b>"VOLVER A CALCULAR"</b> para realizar un nuevo cálculo.</span>
                            <span className="image"><object width="100%" data="img/instructions006.svg"></object></span>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-default" data-dismiss="modal" onClick={this.props.close}>Cerrar</button>
            </div>
        </div>
    }

}

export default Instructions;